module.exports = __webpack_public_path__ + "static/img/100605.67adc52d.png";